import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]

  toggleSubmitButton() {
    const hasChecked = this.checkboxTargets.some(checkbox => checkbox.checked)

    this.submitButtonTargets.forEach(button => {
      if (hasChecked) {
        button.removeAttribute('disabled')
      } else {
        button.setAttribute('disabled', 'disabled')
      }
    })
  }

  confirmDelete(event) {
    const button = event.target
    const confirmMessage = button.dataset.confirm

    if (confirmMessage && !confirm(confirmMessage)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }
}
